import { Link } from "react-router-dom";
import { FaCalendarAlt, FaArrowRight } from "react-icons/fa";
import PageHeader from "../components/layout/PageHeader";
import BlogSidebar from "../components/common/BlogSidebar";
import { blogs } from "../data/blog";

export default function BlogList() {
  return (
    <>
      <PageHeader title="Blog List" crumbs={[{ label: "Blog", to: "/blog-grid" }, { label: "List" }]} />
      <section className="section">
        <div className="container single-layout">
          <div>
            {blogs.map((b) => (
              <article className="card" style={{ display: "flex", marginBottom: 28, flexWrap: "wrap" }} key={b.id}>
                <Link to={`/blogs/${b.id}`} className="blog-img" style={{ width: 300, height: "auto", flexShrink: 0 }}>
                  <img src={b.image} alt={b.title} />
                  <span className="blog-cat">{b.category}</span>
                </Link>
                <div className="blog-body" style={{ flex: 1, minWidth: 240 }}>
                  <div className="blog-meta">
                    <span><FaCalendarAlt /> {b.date}</span>
                    <span>By {b.author}</span>
                  </div>
                  <h3><Link to={`/blogs/${b.id}`}>{b.title}</Link></h3>
                  <p>{b.excerpt}</p>
                  <Link to={`/blogs/${b.id}`} className="read-more">Read More <FaArrowRight /></Link>
                </div>
              </article>
            ))}
          </div>
          <BlogSidebar />
        </div>
      </section>
    </>
  );
}
